import { RootState } from '../combinedReducers'

export const configSelector = (state: RootState) => state.config
